import { mixpanel } from '@fiverr-private/obs';
import {
    MIXPANEL_EVENT_PROPERTIES,
    MIXPANEL_GENERIC_EVENTS,
    MIXPANEL_PAGE_NAMES,
} from '../../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../../shared/utils';

import store from '../../store';

export const reportPageView = (): void => {
    mixpanel.track(MIXPANEL_GENERIC_EVENTS.PAGE_VIEW, {
        ...getDataFromStores(store.user, store.referrer, store.pageType, store.pagePath),
        [MIXPANEL_EVENT_PROPERTIES.PAGE_NAME]: MIXPANEL_PAGE_NAMES.MONOGRAMS_LOGO_IDEAS,
    });
};
